import { render, staticRenderFns } from "./TaskFilterModal.vue?vue&type=template&id=09e53d71&scoped=true"
import script from "./TaskFilterModal.vue?vue&type=script&lang=js"
export * from "./TaskFilterModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e53d71",
  null
  
)

export default component.exports